var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgQuickBooks = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6001 23.9487C9.6001 28.1778 13.0705 31.6077 17.3532 31.6077H18.4607V28.7613H17.3532C14.666 28.7613 12.4798 26.6026 12.4798 23.9487C12.4798 21.2934 14.666 19.1347 17.3532 19.1347H20.0143V34.014C20.0143 35.5848 21.3028 36.8575 22.894 36.8575V16.2898H17.3532C13.0705 16.2898 9.6001 19.7182 9.6001 23.9487ZM30.647 16.2898H29.5394V19.1362H30.647C33.3342 19.1362 35.5204 21.2949 35.5204 23.9487C35.5204 26.604 33.3342 28.7627 30.647 28.7627H27.9859V13.8835C27.9859 12.3126 26.6974 11.04 25.1048 11.04V31.6077H30.647C34.9282 31.6077 38.4001 28.1793 38.4001 23.9487C38.4001 19.7211 34.9282 16.2898 30.647 16.2898Z",
    fill: "#2CA01C"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuickBooks, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/QuickBooks.d2e7ee8b.svg";
export { ForwardRef as ReactComponent };